import { RichTextDocType } from '../types/storyblok';

export const isRichText = (richText: RichTextDocType | undefined): richText is RichTextDocType => {
  return Boolean(richText?.content?.length);
};
